import { Controller } from "@hotwired/stimulus";
import IMask from "imask";

const MASKS = {
  phone: {
    mask: "(000) 000-0000",
    lazy: false,
    placeholderChar: "_",
  },
  ssn: {
    mask: "000-00-0000",
    lazy: true,
    placeholderChar: "_",
  },
};

export default class extends Controller {
  static values = { type: String };

  connect() {
    this.mask = IMask(this.element, MASKS[this.typeValue]);
  }

  disconnect() {
    this.mask?.destroy();
  }
}
